module.exports = __webpack_public_path__ + "img/full0-min.dbae0e4c.png";